module.exports = __webpack_public_path__ + "static/statetoggles-2a237d8dbee513e49230a1a5a8e86f77.png";